export default {
  total_orders: {
    title: 'Bestellungen',
    orders: 'Bestellungen:',
    sales_volume: 'Umsatz:',
    delivery_costs: 'Lieferkosten:',
  },
  cash_orders: {
    title: 'Bezahlung in Bar/ an der Tür',
    orders: 'Bestellungen:',
    sales_volume: 'Umsatz:',
    delivery_costs: 'Lieferkosten:',
  },
  online_orders: {
    title: 'Online-Zahlungen',
    orders: 'Bestellungen:',
    sales_volume: 'Umsatz:',
    delivery_costs: 'Lieferkosten:',
  },
  total: 'Total',
  collected_taxes_list: {
    title: {
      online: 'Online-Zahlung',
      cash: 'Barzahlung',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Artikel',
          quantity: 'Anzahl',
          total: 'Summe Waren inkl. USt.',
        },
        labels: {
          total_refunded: 'Rückerstatten',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'MwSt. %',
          product_type: 'Typ',
          netto: 'Umsatz inkl. MwSt.',
          tax: 'MwSt.',
          brutto: 'MwSt.-Betrag',
        },
        product_types: {
          product: 'Artikel {{percentage}}%',
          order_method_fee: 'Lieferkosten {{percentage}}%',
          customer_service_fee: 'Onlinekostenzuschlag',
        },
      },
    },
  },
};
